import React from 'react'
import pic from '../images/lakeland.png'
import pic2 from '../images/lakeland2.png'

function Navbar() {

  function RedirectLoginPage()
  {
      window.location.replace('/login')
  }

  return (
    <div class='w-full bg-color4 absolute flex flex-row justify-between items-center md:pr-10 pr-3'>
      <div class='lg:w-[20%] md:w-[28%] w-[40%] bg-white flex justify-evenly items-center rounded-ee-lg'>
        <img src={pic} class='w-[28%]'/>
        <img src={pic2} class='w-[28%]'/>
      </div>

      <button class='lg:w-[10%] md:w-[15%] w-[20%] h-fit py-2 bg-color5 text-white text-lg rounded-full' onClick={RedirectLoginPage}>
        Log in
      </button>
    </div>
  )
}

export default Navbar